import { ProviderConfig } from 'launchdarkly-react-client-sdk';

import computeHash from 'utils/computeHash';

import config from './utils/config';

/*
    Returns a ProviderConfig object for the LaunchDarkly React SDK.
    Note: The default user is replaced with the actual user key once authentication is complete.
*/
const getNonAuthLDConfig = (): ProviderConfig => {
  return {
    clientSideID: config.launchDarkly.clientSideID,
    context: {
      key: config.launchDarkly.defaultUserKey,
    },
    options: {
      // the user key is hashed using the SDK key to work with the secure mode.
      hash: computeHash(
        config.launchDarkly.defaultUserKey,
        config.launchDarkly.sdkKey,
      ),
      // bootstrapping decreases the startup time by providing an intial set of flag values.
      // this is done before any connection is established to the LaunchDarkly.
      bootstrap: 'localStorage',
      // client-side SDKs receive updated flag values when they change (either in real-time by streaming or at intervals by polling).
      streaming: false,
      // enabling evaluation reasons will obtain additional information to determine why a user receives a given flag variation.
      evaluationReasons: true,
    },
    reactOptions: {
      // React cannot access keys with a dot notation, so the React SDK automatically changes all flag keys to camel case
      useCamelCaseFlagKeys: false,
    },
  };
};

export default getNonAuthLDConfig;
